import validation from '../../../../../modules/Gull/Framework/validation.js';

const edit = {

	init() {

		// Haal salaris type op als begindatum gewijzigd wordt
		$('#Begindatum').change(function() {
			if ($('#Begindatum').val() != '') {
				$.getJSON(window.app.ajaxPath + $('#form-salarissen').data('werknemer_id') + '/' + $('#form-salarissen').data('salaris_id') + '/get-types/' + $('#Begindatum').val() + '/', function(data) {
					$('.salaris-type').removeClass('d-none').addClass('d-none');
					$('.salaris-type').find('input').each(function() {
						validation.removeRequired(this);
					});
					$.each(data, function(index, val) {
						$('.salaris-type-' + val).removeClass('d-none');
						$('.salaris-type-' + val).find('input').each(function() {
							validation.addRequired(this);
						});
					});
				});
			}
		});

		// Wanneer begindatum verandert, controleer dan of deze niet overlapt met een bestaande salaris
		$('#Begindatum,#Periode').change(function(e) {
			e.preventDefault();
			if (($('#Begindatum').val() != '') && ($('#Periode').val() != '')) {
				$.getJSON(window.app.ajaxPath + $('#form-salarissen').data('werknemer_id') + '/' + $('#form-salarissen').data('salaris_id') + '/duplicate-check/' + $('#Begindatum').val() + '/' + $('#form-salarissen').data('salaris_id') + '/', function(data) {
					if (data != false) {
						// Er is een overlappend salaris
						if (!$('#form_suggestion').is(':visible')) {
							$('#form_suggestion').hide().removeClass('d-none').fadeIn();
							$('#form_continue').hide();
						}
						// var keer = $('#Contract option:selected').attr('keer');
						$('.gevonden-salarissen *').remove();
						$.each(data, function(index, val) {
							var tr = '<tr><td>' + val.begindatum + '</td><td>' + val.einddatum + '</td><td>' + val.action + '</td></tr>';
							$('.gevonden-salarissen').append(tr);
						});
					} else {
						// Er is nog geen overlappend salaris
						edit.hideFormSuggestion();
					}
				});
			}
		});

		$('#Begindatum').trigger('change');

		// Verander jaarloon op basis van het aanpassen van periodeloon en periode
		$('.periodeLoon, #Periode').change(function(e) {
			e.preventDefault();
			edit.calculateJaarLoon();
		});

		$('#Periode').trigger('change');

		// Focus op bovenste veld wanneer pagina geladen is
		$(function() {
			$('#Begindatum').focus();
		});

	},

	// Verberg het blok met als deze zichtbaar is
	hideFormSuggestion: function() {
		$('#form_suggestion').fadeOut(100, function() {
			$('#form_continue').hide().removeClass('d-none').fadeIn();
		});
	},

	// Bereken het jaarloon op basis van perodeloon en periode
	calculateJaarLoon: function() {
		// var keer = $('#Periode option:selected').attr('keer');
		var periode = $('#Periode option:selected').html();
		$('span.periode').html(periode.toLowerCase());
	}

};

export default edit;
